<template>
	<div class="reserve-background-width">
		<v-img
			v-if="reservedaysData.mainimg"
			:src="$store.state.frontServer_upload + reservedaysData.mainimg.url"
			@error="imgError()"
			class="imageButton"
		></v-img>
		<v-img v-else-if="reservedaysData.mainimg === null" :src="defaultImg" class="imageButton"> </v-img>
		<div class="reserveInfo" v-if="reservedaysData.showInfo">
			{{ reservedaysData.title }} <br />
			예약기간 : {{ reservedaysData.openDate | moment('YYYY.MM.DD (ddd)') }} ~ {{ reservedaysData.endDate | moment('YYYY.MM.DD (ddd)') }}
			<br />
			방문기간 : {{ reservedaysData.sdate | moment('YYYY.MM.DD (ddd)') }} ~ {{ reservedaysData.edate | moment('YYYY.MM.DD (ddd)') }}
		</div>
		<v-layout class="pa-4" wrap justify-center>
			<v-flex xs12>
				<btn
					:btn="nextbtn"
					:btn_txt="reservedaysData.btnText ? reservedaysData.btnText : '시작하기'"
					:style="`color:${$store.state.PointColor8}`"
					@click="startSurvey"
				></btn>
			</v-flex>
			<v-img
				v-if="reservedaysData.business.QRlogo"
				max-width="200px"
				max-height="130px"
				contain
				position="top"
				:src="$store.state.backServer + reservedaysData.business.QRlogo.url"
			></v-img>
		</v-layout>
		<!-- 이름 전화 번호 입력 모달 -->
		<reserveStart :setdialog="startDialog" :reservedaysData="reservedaysData" :nextStep="nextStep"></reserveStart>
		<!-- 드래그 버전 설문 모달 -->
		<reserveday-modal :setdialog="reserveDialog" :title="placeTitle" :reservedaysData="reservedaysData"></reserveday-modal>
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { btn, reserveStart, reservedayModal, alertModal5 } from '@/components/index.js'
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
export default {
	components: {
		btn,
		reserveStart,
		reservedayModal,
		alertModal5,
	},
	metaInfo() {
		return {
			title: this.reservedaysData.title,
		}
	},
	data() {
		return {
			defaultImg: require('@/../public/image/default_main.png'),
			placeTitle: '',
			nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.' },
			numSel: { value: '010', outlined: true, class: 'selectNum', items: ['010', '011', '016', '017'] },
			numtxtField: { value: '', outlined: true, placeholder: '나머지 번호를 입력하세요', onlyNumber: true, maxlength: 8 },
			nextbtn: {
				block: true,
				large: true,
				class: 'customBtn',
				color: this.$store.state.PointColor7,
			},
			backbtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				dialog1: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},

			startDialog: {
				step1: true,
				dialog: false,
				nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.', color: 'black' },
				numSel: { value: '010', outlined: true, class: 'selectNum', items: ['010', '011', '016', '017'], color: 'black' },
				numtxtField: {
					type: 'Number',
					value: '',
					outlined: true,
					placeholder: '나머지 번호를 입력하세요',
					onlyNumber: true,
					maxlength: 8,
					max: 99999999,
				},
				phonetxtField: {
					value: '',
					outlined: true,
					placeholder: '문자로 전송된 인증번호를 입력하세요',
					onlyNumber: true,
					maxlength: 6,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
			},
			trackingCodes: [],
			reservedaysData: { business: { QRlogo: null } },
			alertModal: {
				dialog: false,
				text: '이름과 전화번호를 입력해 주세요.',
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			// noInputBox: false,
			btnDisabled: false,
			nowSurvey: {
				num: 0,
				imgs: [],
			},
			surveyLegnth: 0,
			reserveAmount: 0,
		}
	},
	async created() {
		this.$moment.locale('ko', {
			weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
			weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
		})
		await this.reservedays()
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		imgError() {
			this.reservedaysData.mainimg = null
		},
		getLength() {
			let index = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 90)
			if (index !== -1) {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length - 1
				this.$store.state.reservedayInputBox.categories.splice(index, 1)
			} else {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length
			}
			if (this.$route.name === 'reservedirect') {
				let dateIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 30)
				if (dateIndex !== -1) {
					this.$store.state.reservedayInputBox.categories.splice(dateIndex, 1)
					this.surveyLegnth--
				}
				let timeIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 31)
				if (timeIndex !== -1) {
					this.$store.state.reservedayInputBox.categories.splice(timeIndex, 1)
					this.surveyLegnth--
				}
			}
		},
		createTrackingCode() {
			const data = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.$store
				.dispatch('createTrackingCode', data)
				.then(res => {
					this.$store.state.trackingCodeCode = res.data.createTrackingCode.trackingCode.code
					this.$store.state.trackingCodeId = res.data.createTrackingCode.trackingCode.id
					if (!this.reservedaysData.population || this.reservedaysData.population === '설정 해제') {
						if (this.reservedaysData.accessPhones !== '' && this.reservedaysData.accessPhones !== null) {
							this.checkPhone()
						} else {
							this.reserveusers()
						}
					} else {
						this.checkPopulation()
					}
				})
				.catch(() => {})
		},
		async reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			await this.$store.dispatch('reservedays', data).then(async res => {
				let input_boxes
				if (res.data.reservedays[0].event) {
					await this.$store.dispatch('events', { id: res.data.reservedays[0].event }).then(res_event => {
						let obj = {
							id: res_event.data.events[0].id,
							title: res_event.data.events[0].title,
							start: res_event.data.events[0].start,
							code: res_event.data.events[0].code,
							end: res_event.data.events[0].end,
							joinList: res_event.data.events[0].joinList,
							joinNumber: res_event.data.events[0].joinNumber,
							winnerList: res_event.data.events[0].winnerList,
							type: res_event.data.events[0].type,
							status: res_event.data.events[0].status,
							maxcount: res_event.data.events[0].maxcount,
							map: res_event.data.events[0].map,
							priceList: res_event.data.events[0].priceList,
							endLink: res_event.data.events[0].endLink,
							duplicate: res_event.data.events[0].duplicate,
							winnerMessage: res_event.data.events[0].winnerMessage,
							message: res_event.data.events[0].message,
							joinMessage: res_event.data.events[0].joinMessage,
						}
						res.data.reservedays[0].event = obj
					})
				}
				if (res.data.reservedays[0].reserveday_groups) {
					res.data.reservedays[0].reserveday_groups_origin = res.data.reservedays[0].reserveday_groups
						? res.data.reservedays[0].reserveday_groups
						: ''
					let result_li = []
					await this.$store.dispatch('reservedayGroups', { reserveday: res.data.reservedays[0].id }).then(res_reserveday_groups => {
						res_reserveday_groups.data.reservedayGroups.forEach(el => {
							let obj = {
								id: el.id,
								qrcode: el.qrcode,
								title: el.title,
								useYn: el.useYn,
							}
							result_li.push(obj)
						})
					})
					res.data.reservedays[0].reserveday_groups = result_li
				}
				this.reservedaysData = res.data.reservedays[0]

				if (res.data.reservedays[0].business) {
					if (res.data.reservedays[0].business.term) this.$store.state.termId = res.data.reservedays[0].business.term.id
					let li = []
					if (res.data.reservedays[0].business.useTerm) {
						li.push(res.data.reservedays[0].business.useTerm)
					} else li.push(null)
					if (res.data.reservedays[0].business.privacyTerm_reserveday) {
						li.push(res.data.reservedays[0].business.privacyTerm_reserveday)
					} else li.push(null)
					if (res.data.reservedays[0].business.uniqueTerm) {
						li.push(res.data.reservedays[0].business.uniqueTerm)
					} else li.push(null)
					if (res.data.reservedays[0].business.marketingTerm_reserveday) {
						li.push(res.data.reservedays[0].business.marketingTerm_reserveday)
					} else li.push(null)
					if (res.data.reservedays[0].business.adTerm) {
						li.push(res.data.reservedays[0].business.adTerm)
					} else li.push(null)
					this.$store.state.termIdList = li
				}
				// reservedays data 초기화
				if (res.data.reservedays[0].population) {
					let text_copy = JSON.parse(JSON.stringify(res.data.reservedays[0].population))
					res.data.reservedays[0].populationType = text_copy.split('_')[0]
					res.data.reservedays[0].population = text_copy.split('_')[1]
				}
				this.$store.state.reservedayData = res.data.reservedays[0]
				// 설문 데이터 value 삽입
				if (res.data.reservedays[0].business.color) {
					this.$store.state.PointColor7 = res.data.reservedays[0].business.color
					this.nextbtn.color = res.data.reservedays[0].business.color

					this.startDialog.nametxtField.color = res.data.reservedays[0].business.color
					this.startDialog.numSel.color = res.data.reservedays[0].business.color
					this.startDialog.numtxtField.color = res.data.reservedays[0].business.color
				}
				if (res.data.reservedays[0].business.btnColor) {
					this.$store.state.PointColor8 = res.data.reservedays[0].business.btnColor
				}
				if (res.data.reservedays[0].reserveInputBoxId) {
					await this.$store.dispatch('inputboxes', { id: res.data.reservedays[0].reserveInputBoxId }).then(resData => {
						if (resData.data.inputBoxes[0]) {
							// 시간/달력 검사
							let checkPicker = resData.data.inputBoxes[0].categories.findIndex(e => e.type === 30)
							let checkTime = resData.data.inputBoxes[0].categories.findIndex(e => e.type === 31)

							if (checkPicker === -1) {
								/// 달력 삽입
								resData.data.inputBoxes[0].categories.push({
									type: 30,
									listorder: resData.data.inputBoxes[0].categories.length + 1,

									code: res.data.reservedays[0].code,
								})
							}
							if (checkTime === -1) {
								// 시간 삽입
								resData.data.inputBoxes[0].categories.push({
									type: 31,
									listorder: resData.data.inputBoxes[0].categories.length + 2,

									code: res.data.reservedays[0].code,
								})
							}
							this.placeTitle = res.data.reservedays[0].title
							resData.data.inputBoxes[0].categories.forEach(element => {
								if (element.tag === 'location') {
									if (element.defalutLocation) {
										this.$store.state.searchsel_city1.value = element.defalutLocation.split('_')[0]
										this.loc_firstSelect(element.defalutLocation.split('_')[0])
										if (element.defalutLocation.split('_')[1]) {
											this.loc_twoSelect(element.defalutLocation.split('_')[1])
											this.$store.state.searchsel_city2.value = element.defalutLocation.split('_')[1]
										}
										if (element.defalutLocation.split('_')[2]) {
											this.$store.state.searchsel_city3.value = element.defalutLocation.split('_')[2]
										}
									} else {
										this.$store.state.searchsel_city2.items = location1['서울특별시'].sort()
										this.$store.state.searchsel_city3.items = location2['서울특별시']['강남구'].sort()
									}
								}
								if (element.type === 10) {
									element.imgType = element.imgType ? element.imgType : '리스트형'
									element.value = ''
									element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
									element.nowRadioValue = ''
									element.etc = ''
									if (element.detailImg) {
										element.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + element.detailImg.url
									}
									if (element.previewImg) {
										element.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + element.previewImg.url
									}
									element.category_details.forEach(detail => {
										if (detail.detailImg) {
											detail.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + detail.detailImg.url
										}
										if (detail.previewImg) {
											detail.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + detail.previewImg.url
										}
									})
								} else if (element.type === 11) {
									element.imgType = element.imgType ? element.imgType : '리스트형'
									if (element.detailImg) {
										element.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + element.detailImg.url
									}
									if (element.previewImg) {
										element.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + element.previewImg.url
									}
									element.category_details.forEach(detail => {
										if (!element.items) {
											element.items = []
										}
										element.items.push({
											value: '',
											label: detail.detailname,
											color: '',
											class: '',
											errorMessage: '',
											hideDetail: true,
											detailcode: detail.detailcode,
										})
										if (detail.detailImg) {
											detail.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + detail.detailImg.url
										}
										if (detail.previewImg) {
											detail.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + detail.previewImg.url
										}
									})
								} else if (element.type === 12) {
									element.items = {
										label: '',
										value: '',
										errorMessage: '',
										hideDetail: true,
										outlined: true,
										color: this.$store.state.PointColor7,
									}
								} else if (element.type === 20) {
									element.items = {
										value: '',
										maxlength: '255',
										outlined: true,
										autofocus: false,
										hideDetail: false,
										errorMessage: '',
										color: this.$store.state.PointColor7,
									}
									if (element.detailImg) {
										element.detailImg.url = process.env.VUE_APP_CUSTOMER_URL + element.detailImg.url
									}
									if (element.previewImg) {
										element.previewImg.url = process.env.VUE_APP_CUSTOMER_URL + element.previewImg.url
									}
								}
							})
							input_boxes = resData.data.inputBoxes[0]
						}
					})
				} else {
					// this.noInputBox = true
					// this.alertModal2.text = '연결된 설문 정보가 없습니다. 등록고객 관리에서 설문정보를 등록해주세요.'
					// this.alertModal2.dialog = true
					// this.btnDisabled = true
					this.placeTitle = res.data.reservedays[0].title
					input_boxes = {
						categories: [
							{
								type: 30,
								listorder: 1,
								code: res.data.reservedays[0].code,
							},
							{
								type: 31,
								listorder: 2,
								code: res.data.reservedays[0].code,
							},
						],
					}
				}
				this.$store.state.reservedayInputBox = input_boxes
				this.$store.state.maxcount = res.data.reservedays[0].maxcount
				this.$store.state.nodaySetting = res.data.reservedays[0].nodaySetting
				this.$store.state.timeRange = res.data.reservedays[0].timeRange
				this.$store.state.startDate = this.$moment(res.data.reservedays[0].sdate)
					.add(9, 'hours')
					.format('YYYY-MM-DD')
				this.$store.state.endDate = this.$moment(res.data.reservedays[0].edate)
					.add(9, 'hours')
					.format('YYYY-MM-DD')
				this.getLength()
			})
		},
		reserveusers() {
			const data = {
				rsdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T' + this.$moment(new Date()).format('HH:mm:ss') + '.000Z',
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,

				code: this.$route.params.code,
				status: 1,
			}
			this.$store
				.dispatch('simpleReserveusers', data)
				.then(res => {
					// if (res.data.reserveusers[0].fileUpload) {
					// 	this.$store.state.userimgfile = res.data.reserveusers[0].fileUpload
					// }
					this.$store.state.loading = false
					// 남양주 한양병원 셋팅
					if (res.data.reserveusers.length === 0) {
						if (this.reservedaysData.input_box !== null) {
							this.reserveDialog.title = this.reservedaysData.input_box.name
						}
						if (this.reservedaysData.inputBoxType === '2') {
							this.reserveDialog.dialog1 = true
							this.startDialog.dialog = false
							this.nowSurvey.num = 0
						} else {
							this.startDialog.dialog = false
							this.reserveDialog.dialog = true
							this.reserveDialog.step1 = true
							this.reserveDialog.step2 = false
							this.reserveDialog.step3 = false
							this.$store.state.reserveusersData = {} //설문 답변 초기화
						}
					} else {
						if (this.reservedaysData.input_box !== null) {
							this.reserveDialog.title = this.reservedaysData.input_box.name
						}
						if (this.reservedaysData.inputBoxType === '2') {
							this.startDialog.dialog = false
							this.reserveDialog.dialog1 = true
							this.nowSurvey.num = this.reservedaysData.input_box.categories.length
						} else {
							this.startDialog.dialog = false
							this.reserveDialog.dialog = true
							this.reserveDialog.step1 = false
							this.reserveDialog.step2 = true
							this.reserveDialog.step3 = false
						}
						this.$store.state.CompanionData = res.data.reserveusers[0].companion
						this.$store.state.reserveusersData = res.data.reserveusers[0]
						this.$store.state.reserveuserId = res.data.reserveusers[0].id
						this.$store.state.reserveUserData = {
							reserveUpdateDate: res.data.reserveusers[0].updated_at,
							name: res.data.reserveusers[0].name,
							reservedDate: res.data.reserveusers[0].rdate,
						}
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		nextStep() {
			// this.$store.state.loading = true
			if (this.startDialog.nametxtField.value === '') {
				this.alertModal.text = '이름과 전화번호를 입력해 주세요.'
				return (this.alertModal.dialog = true)
			}
			if (this.startDialog.numtxtField.value === '') {
				this.alertModal.text = '이름과 전화번호를 입력해 주세요.'
				return (this.alertModal.dialog = true)
			}

			if (this.startDialog.numtxtField.value.length < 7) {
				this.alertModal.text = '휴대전화번호를 정확히 입력해주세요.'
				return (this.alertModal.dialog = true)
			}

			// const data = {
			// 	phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			// }
			// this.$store
			// 	.dispatch('trackingCodes', data)
			// 	.then(res => {
			this.reserveDialog.inputUserData = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			// 		if (res.data.trackingCodes.length === 0) {
			// 			this.createTrackingCode()
			// 		} else {
			// 			this.$store.state.trackingCodeId = res.data.trackingCodes[0].id
			// 			this.$store.state.trackingCodeCode = res.data.trackingCodes[0].code
			if (!this.reservedaysData.population || this.reservedaysData.population === '설정 해제') {
				if (this.reservedaysData.accessPhones !== '' && this.reservedaysData.accessPhones !== null) {
					this.checkPhone()
				} else {
					this.reserveusers()
				}
			} else {
				this.checkPopulation()
			}
			// }
			// })
			// .catch(err => {
			// 	console.log(err)
			// 	alert('오류 발생 새로고침 후 다시 시도해 주세요.')
			// 	this.$store.state.loading = false
			// })
		},
		changeTypeText(data) {
			if (data === 11) {
				return 'checkbox'
			} else if (data === 10 || data === 12) {
				return 'checkone'
			} else if (data === 20) {
				return 'textfiled'
			}
		},
		change() {
			return {}
		},
		disableNext() {
			if (this.startDialog.numtxtField.value && this.startDialog.nametxtField.value) {
				this.nextbtn.disabled = false
			} else {
				this.nextbtn.disabled = true
			}
			this.reserveDialog.name = this.startDialog.nametxtField.value
		},
		clickdoneBtn() {
			this.reserveDialog.dialog = false
		},
		startSurvey() {
			this.startDialog.nametxtField.value = ''
			this.startDialog.numSel.value = '010'
			this.startDialog.numtxtField.value = ''
			this.startDialog.phonetxtField.value = ''
			if (
				this.$moment(this.$moment().format('YYYY-MM-DD HH:mm')).isBetween(
					this.$moment().format('YYYY-MM-DD HH:mm'),
					this.$moment(this.reservedaysData.openDate)
						.subtract(1, 'm')
						.format('YYYY-MM-DD HH:mm'),
					undefined,
					'[]',
				)
			) {
				this.alertModal2.text = '본 방문예약 서비스 오픈되지 않았습니다.'
				this.alertModal2.dialog = true
			} else {
				if (
					this.$moment(this.$moment().format('YYYY-MM-DD HH:mm')).isBetween(
						this.$moment().format('YYYY-MM-DD HH:mm'),
						this.$moment(this.reservedaysData.endDate)
							.subtract(1, 'm')
							.format('YYYY-MM-DD HH:mm'),
						undefined,
						'[]',
					)
				) {
					this.startDialog.dialog = true
				} else {
					this.alertModal2.text = '본 방문예약 서비스는 종료되었습니다.'
					this.alertModal2.dialog = true
				}
			}
		},
		maxcountCheck() {
			this.$store.state.loading = true
			const data = {
				// rsdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T' + this.$moment(new Date()).format('HH:mm:ss') + '.000Z',
				// redate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T' + this.$moment(new Date()).format('HH:mm:ss') + '.000Z',
				rsdate: this.reservedaysData.sdate,
				redate: this.$moment(this.reservedaysData.edate)
					.add(1, 'days')
					.format('YYYY-MM-DD HH:mm'),

				code: this.$route.params.code,
				status: 1,
			}
			this.$store
				.dispatch('findReserveusers', data)
				.then(res => {
					let reserveAmount = res.data.reserveusers.length
					this.$store.state.loading = false

					let openDate = this.$moment(this.reservedaysData.openDate).format('YYYY-MM-DD HH:mm')
					let endDate = this.$moment(this.reservedaysData.endDate).format('YYYY-MM-DD HH:mm')
					let dateCheck = this.$moment(this.$moment().format('YYYY-MM-DD HH:mm')).isBetween(openDate, endDate, undefined, '[]')
					if (dateCheck) {
						this.startDialog.dialog = true
						if (reserveAmount >= this.reservedaysData.totalMaxcount) {
							this.alertModal2.text = '해당 사업지의 상담 신청 예약인원이 초과되었습니다.'
							this.alertModal2.dialog = true
						}
					} else {
						let beforeCheck = this.$moment(this.$moment().format('YYYY-MM-DD HH:mm')).isBefore(openDate)
						let afterCheck = this.$moment(this.$moment().format('YYYY-MM-DD HH:mm')).isAfter(endDate)

						if (beforeCheck) {
							this.alertModal2.text = `현재 방문예약 기간이 아닙니다. \n 방문예약 시작일:\n${this.$moment(
								this.reservedaysData.openDate,
							).format('YYYY년 MM월 DD일 HH시 mm분')} \n 방문예약 종료일:\n${this.$moment(this.reservedaysData.endDate).format(
								'YYYY년 MM월 DD일 HH시 mm분',
							)}`
							this.alertModal2.dialog = true
						}
						if (afterCheck) {
							this.alertModal2.text = `현재 방문예약 기간이 종료되었습니다. \n 방문예약 시작일:\n${this.$moment(
								this.reservedaysData.openDate,
							).format('YYYY년 MM월 DD일 HH시 mm분')} \n 방문예약 종료일:\n${this.$moment(this.reservedaysData.endDate).format(
								'YYYY년 MM월 DD일 HH시 mm분',
							)}`
							this.alertModal2.dialog = true
						}
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		checkPopulation() {
			let input
			if (this.$store.state.reservedayData.populationType === 'e') {
				input = {
					code: this.$store.state.reservedayData.population,
				}
				this.$store
					.dispatch('eventJoins', input)
					.then(res => {
						if (res.data.eventJoins.length === 0) {
							this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
							return (this.alertModal.dialog = true)
						} else {
							let inputData = {
								phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
								code: this.$store.state.reservedayData.population,
							}
							this.$store.dispatch('eventJoins', inputData).then(res => {
								if (res.data.eventJoins.length > 0) {
									this.reserveusers()
								} else {
									this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
									return (this.alertModal.dialog = true)
								}
							})
						}
					})
					.catch(() => {
						this.$store.state.loading = false
					})
			} else {
				input = {
					phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
					code: this.$store.state.reservedayData.population,
				}
				this.$store
					.dispatch('findReserveusers', input)
					.then(res => {
						if (res.data.reserveusers.length === 0) {
							this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
							return (this.alertModal.dialog = true)
						} else {
							this.reserveusers()
						}
					})
					.catch(() => {
						this.$store.state.loading = false
					})
			}
		},
		checkPhone() {
			let phone = this.startDialog.numSel.value + this.startDialog.numtxtField.value
			let realPhone = phone
				.replace(/[^0-9]/g, '')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-')
			let nameCheck = this.reservedaysData.accessPhones.map(x => x.phone).indexOf(realPhone)
			if (nameCheck !== -1) {
				this.reserveusers()
			} else {
				this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
				this.alertModal.dialog = true
				this.startDialog.dialog = false
			}
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		closePage() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
	},
}
</script>

<style lang="scss">
.reserve-background-width {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}

.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
</style>
<style lang="scss" scoped>
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
</style>
